import { ErrorHandler, NgModule } from '@angular/core';
import { DateSelectorComponent } from './components/date-selector/date-selector.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsersSharedService } from './services/users-shared.service';
import { UserResolver } from './resolvers/user.resolver';
import { GlobalErrorHandler } from './utils/global-error-handler';
import { MaterialModule } from './modules/material.module';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { GlobalSpinnerService } from './components/loader-service/global-spinner.service';
import { DialogsService } from './components/dialogs/dialogs.service';
import { RouterModule } from '@angular/router';
import { ActivityStatusCircleComponent } from './components/domain-specific/activity-status-circle.component';
import { AdUnitTagPreviewButtonComponent } from './components/domain-specific/ad-unit-tag-preview-button.component';
import { AdUnitTagPreviewDialogComponent } from './components/domain-specific/ad-unit-tag-preview-dialog.component';
import { ClipboardModule } from 'ngx-clipboard';
import { DevicePlacementIconComponent } from './components/domain-specific/device-placement-icon.component';
import { PublisherRequestStatusPlateComponent } from './components/domain-specific/publisher-request-status-plate.component';
import { CommentDialogComponent } from './components/domain-specific/comment-dialog.component';
import { CommentButtonComponent } from './components/domain-specific/comment-button.component';
import { ActivityStatusCirclePlateComponent } from './components/domain-specific/activity-status-circle-plate.component';
import { PublisherRequestStatusCirclePlateComponent } from './components/domain-specific/publisher-request-status-circle-plate.component';
import { AdstxtDiffDialogComponent } from './components/domain-specific/adstxt-diff-dialog.component';
import { UploadButtonComponent } from './components/upload-button.component';
import { AttachmentIconButtonComponent } from './components/attachment-icon-button.component';
import { AdUnitPixelTagPreviewButtonComponent } from './components/domain-specific/ad-unit-pixel-preview-button.component';
import { AdUnitPixelTagPreviewDialogComponent } from './components/domain-specific/ad-unit-pixel-tag-preview-dialog.component';
import { ListEditorComponent } from './components/list-editor.component';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog.component';
import { GlobalSpinnerComponent } from './components/loader-service/global-spinner.component';
import { SnackBarService } from './services/snackbar.service';
import { AdsTxtComponent } from './components/ads-txt/ads-txt.component';
import { FiltersDropdownComponent } from './components/table/filters-dropdown.component';
import { ProgressCircleComponent } from './components/progress-circle.component';
import { BlocklistAdTracesDialogComponent } from './components/domain-specific/blocklist-ad-traces-dialog.component';
import { BlocklistAttachmentsDialogComponent } from './components/domain-specific/blocklist-attachments-dialog.component';
import { CustomUploadButtonComponent } from './components/custom-upload-button.component';
import { CustomUploadButtonIconComponent } from './components/custom-upload-button-icon.component';
import { AccountComponent } from './components/account/account.component';
import { MatTableColVisComponent } from './components/table/mat-table-col-vis.component';
import { CmDropdownComponent, CmDropdownTriggerComponent } from './components/table/cm-dropdown.component';
import { CmButtonDropdownComponent } from './components/table/cm-button-dropdown.component';
import { DateRangeChooserComponent } from './components/date-selector/date-range-chooser.component';
import { DateRangeDropdownComponent } from './components/table/date-range-dropdown.component';
import { DateChooserDropdownComponent } from './components/table/date-dropdown.component';
import { CdkDetailRowDirective } from './components/table/cdk-detail-row.directive';
import { NewFeatureFlagComponent } from './components/new-feature-flag.component';
import { SimpleListPreviewPopoverComponent } from './components/simple-list-preview-popover.component';
import { PublisherInvoicesService } from './services/publisher-invoices.service';
import { CmCardFiltersComponent } from './components/cm-card-filters.component';
import { DeleteDialogComponent } from './components/dialogs/delete-dialog.component';
import { PublisherFilesService } from './services/publisher-files.service';
import { BidderConfigPreviewDialogComponent } from './components/bidder-config-preview-dialog.component';
import { DomainStatusCircleComponent } from './components/domain-specific/domain-status-circle.component';
import { PublisherStatusCircleComponent } from './components/domain-specific/publisher-status-circle.component';
import { DomainStatusCirclePlateComponent } from './components/domain-specific/domain-status-circle-plate.component';
import { DomainStatusBoxComponent } from './components/domain-specific/domain-status-box.component';
import { PublisherStatusCirclePlateComponent } from './components/domain-specific/publisher-status-circle-plate.component';
import { PublisherStatusBoxComponent } from './components/domain-specific/publisher-status-box.component';
import { WebStatsStatusIconComponent } from './components/domain-specific/web-stats-status-icon.component';
import { CmPopoverActionComponent, CmPopoverComponent, CmPopoverContentComponent } from './components/cm-popover.component';
import { AdstxtStatusIconComponent } from './components/domain-specific/adstxt-status-icon.component';
import { DomainDpStatusBoxComponent } from './components/domain-specific/domain-dp-status-box.component';
import { DomainDpStatusCircleComponent } from './components/domain-specific/domain-dp-status-circle.component';
import { AdstxtMissingRecordsDialogComponent } from './components/domain-specific/adstxt-missing-records-dialog.component';
import { ActivityStatusBoxComponent } from './components/domain-specific/activity-status-status-box.component';
import { DomainActivityStatusCirclePlateComponent } from './components/domain-specific/domain-activity-status-circle-plate.component';
import { PopoverListComponent } from './components/cm-popover-list.component';
import { AdstxtStatusDetailsComponent } from './components/domain-specific/adstxt-status-details.component';
import { PulsingIndicatorComponent } from './components/pulsing-indicator.component';
import { AddEditNoteDialogComponent } from './components/dialogs/add-edit-note-dialog.component';
import { NoteWithFileEditorDialogComponent } from './components/dialogs/note-with-file-editor-dialog.component';
import { DeleteCommentDialogComponent } from './components/dialogs/delete-comment-dialog.component';
import { SiteMultiselectSearchComponent } from './components/multiselect-search/site-multiselect-search.component/site-multiselect-search.component';
import { UnitMultiselectSearchComponent } from './components/multiselect-search/unit-multiselect-search.component/unit-multiselect-search.component';
import { PublisherMultiselectSearchACComponent } from './components/multiselect-search/publisher-multiselect-search-ac/publisher-multiselect-search-ac.component';
import { SidebarShowHideDirective } from './components/sidebar-show-hide.directive';
import { DragAndDropDirective } from './components/drag-and-drop.directive';
import { CmTableColumnCommonService } from './components/table/cm-table-column-common.service';
import { ReportRunnerComponent } from './components/report/report-runner.component';
import { ReportRunnerService } from './components/report/report-runner.service';
import { CustomUploadMultipleButtonComponent } from './components/custom-upload-multiple-button.component';
import { AdStatsTipaltiService } from './services/ad-stats-tipalti.service';
import { AdStatsSupportTicketsService } from './services/ad-stats-support-tickets.service';
import { UserEmailAutocompleteComponent } from './components/user-email-autocomplete.component';
import { PublisherAutocompleteComponent } from './components/publisher-autocomplete.component';
import { AdUnitAutocompleteChipsComponent } from './components/ad-unit-autocomplete-chips.component';
import { AdUnitAutocompleteComponent } from './components/ad-unit-autocomplete.component';
import { AppTopbarComponent } from './components/topbar/app-topbar.component';
import { AdStatsAlertsService } from './services/ad-stats-alerts.service';
import { AdStatsDpInventoryBlockedDomainsService } from './services/ad-stats-dp-inventory-blocked-domains.service';
import { AdStatsWidgetTypesService } from './services/ad-stats-widget-types.service';
import { AdStatsBlockedDomainsService } from './services/ad-stats-blocked-domains.service';
import { AdStatsPublishersService } from './services/ad-stats-publishers.service';
import { AdStatsPublisherOnboardingService } from './services/ad-stats-publisher-onboarding.service';
import { AdStatsDiscrepanciesService } from './services/ad-stats-discrepancies.service';
import { AdStatsDomainsService } from './services/ad-stats-domains.service';
import { AdStatsAppsService } from './services/ad-stats-apps.service';
import { AdStatsBridgeAdUnitsService } from './services/ad-stats-bridge-ad-units.service';
import { AdStatsDemandPartnersService } from './services/ad-stats-demand-partners.service';
import { AdStatsConfiantService } from './services/ad-stats-confiant.service';
import { AdStatsDfpService } from './services/ad-stats-dfp.service';
import { AdStatsUserActivityService } from './services/ad-stats-user-activity.service';
import { AdStatsOptimizationsService } from './services/ad-stats-optimizations.service';
import { UsersService } from './services/users.service';
import { UserEmailAutocompleteChipsComponent } from './components/user-email-autocomplete-chips.component';
import { KnDomainWebStatsDialogComponent } from './components/domain-specific/kn-domain-webstats-dialog.component';
import { CustomUploadMenuButtonComponent } from './components/custom-upload-menu-button.component';
import { TooltipIconComponent } from './components/tooltip-icon.component';
import {VastIntegrationDialogComponent} from './components/vast-integration-dialog.component';

@NgModule({
  declarations: [
    DateSelectorComponent,
    TopbarComponent,
    PageNotFoundComponent,
    ActivityStatusCircleComponent,
    DomainStatusCirclePlateComponent,
    DomainStatusBoxComponent,
    DomainDpStatusCircleComponent,
    DomainDpStatusBoxComponent,
    PublisherStatusCircleComponent,
    PublisherStatusCirclePlateComponent,
    PublisherStatusBoxComponent,
    DomainStatusCircleComponent,
    AdUnitTagPreviewButtonComponent,
    AdUnitPixelTagPreviewButtonComponent,
    AdUnitTagPreviewDialogComponent,
    AdUnitPixelTagPreviewDialogComponent,
    DevicePlacementIconComponent,
    PublisherRequestStatusPlateComponent,
    ActivityStatusBoxComponent,
    ActivityStatusCirclePlateComponent,
    PublisherRequestStatusCirclePlateComponent,
    CommentDialogComponent,
    CommentButtonComponent,
    AdstxtDiffDialogComponent,
    UploadButtonComponent,
    AttachmentIconButtonComponent,
    AdstxtMissingRecordsDialogComponent,
    DomainActivityStatusCirclePlateComponent,
    ListEditorComponent,
    ConfirmDialogComponent,
    DeleteDialogComponent,
    GlobalSpinnerComponent,
    AdsTxtComponent,
    FiltersDropdownComponent,
    ProgressCircleComponent,
    CmPopoverComponent,
    PopoverListComponent,
    BlocklistAttachmentsDialogComponent,
    AdstxtStatusDetailsComponent,
    BlocklistAdTracesDialogComponent,
    CustomUploadButtonComponent,
    CustomUploadMultipleButtonComponent,
    AccountComponent,
    MatTableColVisComponent,
    CmDropdownComponent,
    CmDropdownTriggerComponent,
    CmButtonDropdownComponent,
    DateRangeChooserComponent,
    DateRangeDropdownComponent,
    DateChooserDropdownComponent,
    CdkDetailRowDirective,
    NewFeatureFlagComponent,
    SimpleListPreviewPopoverComponent,
    CmPopoverActionComponent,
    CmPopoverContentComponent,
    CmCardFiltersComponent,
    CustomUploadButtonIconComponent,
    CustomUploadMenuButtonComponent,
    BidderConfigPreviewDialogComponent,
    VastIntegrationDialogComponent,
    WebStatsStatusIconComponent,
    AdstxtStatusIconComponent,
    PulsingIndicatorComponent,
    AddEditNoteDialogComponent,
    NoteWithFileEditorDialogComponent,
    DeleteCommentDialogComponent,
    SiteMultiselectSearchComponent,
    UnitMultiselectSearchComponent,
    PublisherMultiselectSearchACComponent,
    SidebarShowHideDirective,
    DragAndDropDirective,
    ReportRunnerComponent,
    UserEmailAutocompleteComponent,
    AdUnitAutocompleteChipsComponent,
    PublisherAutocompleteComponent,
    AdUnitAutocompleteComponent,
    TooltipIconComponent,
    UserEmailAutocompleteChipsComponent,
    AppTopbarComponent,
    KnDomainWebStatsDialogComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MaterialModule,
    RouterModule,
    ClipboardModule,
  ],
  providers: [
    UserResolver,
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    SnackBarService,
    GlobalSpinnerService,
    DialogsService,
    CmTableColumnCommonService,
    ReportRunnerService,
    AdStatsAlertsService,
    AdStatsBlockedDomainsService,
    AdStatsDpInventoryBlockedDomainsService,
    AdStatsWidgetTypesService,
    AdStatsPublishersService,
    AdStatsPublisherOnboardingService,
    AdStatsDiscrepanciesService,
    AdStatsDomainsService,
    AdStatsAppsService,
    AdStatsOptimizationsService,
    AdStatsBridgeAdUnitsService,
    AdStatsDemandPartnersService,
    AdStatsConfiantService,
    AdStatsDfpService,
    AdStatsUserActivityService,
    AdStatsSupportTicketsService,
    AdStatsTipaltiService,
    UsersService,
    UsersSharedService,
    PublisherInvoicesService,
    PublisherFilesService,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DateSelectorComponent,
    TopbarComponent,
    MaterialModule,
    PublisherStatusCircleComponent,
    PublisherStatusCirclePlateComponent,
    PublisherStatusBoxComponent,
    DomainStatusCircleComponent,
    DomainStatusBoxComponent,
    DomainStatusCirclePlateComponent,
    DomainDpStatusBoxComponent,
    DomainDpStatusCircleComponent,
    ActivityStatusCircleComponent,
    ActivityStatusCirclePlateComponent,
    ActivityStatusBoxComponent,
    AdUnitTagPreviewButtonComponent,
    AdUnitPixelTagPreviewButtonComponent,
    AdUnitTagPreviewDialogComponent,
    AdUnitPixelTagPreviewDialogComponent,
    DevicePlacementIconComponent,
    AdstxtMissingRecordsDialogComponent,
    PublisherRequestStatusPlateComponent,
    PublisherRequestStatusCirclePlateComponent,
    CommentDialogComponent,
    CommentButtonComponent,
    AdstxtDiffDialogComponent,
    AdstxtStatusIconComponent,
    AdstxtStatusDetailsComponent,
    CmPopoverComponent,
    PopoverListComponent,
    CmPopoverActionComponent,
    DomainActivityStatusCirclePlateComponent,
    CmPopoverContentComponent,
    UploadButtonComponent,
    AttachmentIconButtonComponent,
    ListEditorComponent,
    ConfirmDialogComponent,
    GlobalSpinnerComponent,
    AdsTxtComponent,
    FiltersDropdownComponent,
    MatTableColVisComponent,
    ProgressCircleComponent,
    BlocklistAttachmentsDialogComponent,
    BlocklistAdTracesDialogComponent,
    CustomUploadButtonComponent,
    CustomUploadMultipleButtonComponent,
    AccountComponent,
    CmDropdownComponent,
    CmButtonDropdownComponent,
    CmDropdownTriggerComponent,
    DateRangeChooserComponent,
    DateChooserDropdownComponent,
    DateRangeDropdownComponent,
    CdkDetailRowDirective,
    NewFeatureFlagComponent,
    SimpleListPreviewPopoverComponent,
    CmCardFiltersComponent,
    CustomUploadButtonIconComponent,
    BidderConfigPreviewDialogComponent,
    VastIntegrationDialogComponent,
    WebStatsStatusIconComponent,
    PulsingIndicatorComponent,
    AddEditNoteDialogComponent,
    NoteWithFileEditorDialogComponent,
    DeleteCommentDialogComponent,
    SiteMultiselectSearchComponent,
    UnitMultiselectSearchComponent,
    PublisherMultiselectSearchACComponent,
    SidebarShowHideDirective,
    DragAndDropDirective,
    ReportRunnerComponent,
    UserEmailAutocompleteComponent,
    UserEmailAutocompleteChipsComponent,
    AdUnitAutocompleteChipsComponent,
    PublisherAutocompleteComponent,
    AdUnitAutocompleteComponent,
    AppTopbarComponent,
    TooltipIconComponent,
    CustomUploadMenuButtonComponent,
    KnDomainWebStatsDialogComponent
  ],
  entryComponents: [
    AdUnitTagPreviewDialogComponent,
    CommentDialogComponent,
    ConfirmDialogComponent,
    DeleteDialogComponent,
    AdstxtDiffDialogComponent,
    AdstxtMissingRecordsDialogComponent,
    AdUnitPixelTagPreviewDialogComponent,
    BidderConfigPreviewDialogComponent,
    VastIntegrationDialogComponent,
    AddEditNoteDialogComponent,
    NoteWithFileEditorDialogComponent,
    DeleteCommentDialogComponent,
    BlocklistAttachmentsDialogComponent,
    KnDomainWebStatsDialogComponent
  ]
})
export class CmSharedModule {

}
